import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Subject, Subscription } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { CdkTextareaAutosize } from "@angular/cdk/text-field";

@Component({
    selector: 'app-weave-textarea',
    templateUrl: './weave-textarea.component.html',
    styleUrls: ['./weave-textarea.component.scss'],
    standalone: false
})
export class WeaveTextareaComponent implements OnInit, OnDestroy {
  @Input() data: string;
  @Input() label: string = "";
  @Input() placeholder: string = "";
  @Input() description: string = "";
  @Input() maxlength: number = 524288;
  @Input() rows: number = -1;
  @Input() disabledFlag: boolean = true;
  @Input() required: boolean = false;
  @Input() longTitle: boolean = false;
  @Output() focusOut: EventEmitter<string> = new EventEmitter<string>();
  @Output() keyUp: EventEmitter<string> = new EventEmitter<string>();
  @Output() keyUpDebounced: EventEmitter<string> = new EventEmitter<string>();
  tempValue: any;
  @ViewChild('autosize') autosize: CdkTextareaAutosize;

  private keyUpDebouncedSubject  = new Subject<string>();
  private keyUpDebouncedSubscription: Subscription;
  id: string = "";

  constructor() {}

  ngOnInit() {
    this.id = "weave-input-" + Math.floor(Math.random() * 1000);
    if(this.rows > -1) {
      this.setRows( this.rows );
    }
    this.keyUpDebouncedSubscription = this.keyUpDebouncedSubject
      .pipe(
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe((results: string) => (this.keyUpDebounced.emit(results)));
  }

  onFocusOut() {
    this.focusOut.emit(this.data);
  }

  onKeyUp() {
    this.keyUp.emit(this.data);
    this.keyUpDebouncedSubject.next(this.data)
  }

  setRows(minRows: number) {
    if(this.autosize) {
      this.autosize.minRows = minRows;
      // Trigger the autosize to update
      this.autosize.resizeToFitContent( true );
    }
  }


  startEdit() {
    this.tempValue = this.data;
  }

  undo() {
    this.data = this.tempValue;
  }

  ngOnDestroy() {
    this.keyUpDebouncedSubscription.unsubscribe();
  }

}
